import React from "react";

const Section4Registration = () => (
  <>
    <h2>4. User Account Registration, Management, and Security</h2>
    <p>
    To access and use the Service, you may be required to register for an Account. When registering, you agree to provide accurate, current, and complete information. You are responsible for maintaining the confidentiality of your Account credentials, including your username and password, and for all activities that occur under your Account. You must immediately notify Comparedly.com of any unauthorized access to or use of your Account or any other breach of security. Comparedly.com will not be liable for any loss or damage arising from your failure to comply with these obligations. You can manage your Account information and subscription details through your Account settings. It is recommended that you choose a strong password and update it periodically to protect your Account.
    </p>
  </>
);

export default Section4Registration;
